<div class="content">
    <img class="img" alt="time" src="../../assets/img/time_pic.svg">
    <h3>Estás intentando ingresar en un horario no disponible</h3>
    <p class="section">Recuerda que el SIS está disponible de lunes a sábado de 7:00 am a 8:00 pm</p>
</div>
